import React from "react";
import { classNames } from "helpers";
import { DropdownItemProps } from "./types";

const DropdownItem: React.FC<DropdownItemProps> = (
  props: DropdownItemProps
) => {
  const { label, value, text, image, color, isPlaceholder, onClick } = props;

  return (
    <>
      <li
        className={classNames(
          "relative cursor-default select-none py-2.5 pl-3 pr-7 border-t border-[#EAECF0] mt-[-1px] hover:bg-blue-600 hover:cursor-pointer hover:text-white",
          // Prvi redak nije podatak nego brisanje odabira — mora se razlikovati od stvarnih opcija.
          isPlaceholder ? "text-slate-400 bg-slate-50/70" : "text-[#344054]"
        )}
        id="listbox-option-0"
        role="option"
        aria-selected={false}
        onClick={(e) => onClick(e, value)}
        value={value}
        data-label={label}
      >
        <div className="flex items-center">
          {color && (
            <span
              className="h-2.5 w-2.5 block mr-2 flex-shrink-0 rounded-full border border-slate-200"
              style={{ backgroundColor: color }}
            />
          )}
          {image && !color && (
            <img
              src={image}
              alt=""
              className="h-5 w-5 block mr-3 flex-shrink-0 rounded-full"
            />
          )}
          <span className="font-normal  block truncate w-full text-sm ">{text}</span>
        </div>
      </li>
    </>
  );
};

export default React.memo(DropdownItem);
